import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Company } from '@/api';
import { useOpenApi } from '@/common/providers/open-api-provider';

export function useFetchCompany(companyId: string): {
    status: 'error' | 'success' | 'pending';
    company: Company | undefined;
    refetch: () => void;
} {
    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    const { status, data, refetch } = useQuery({
        queryKey: ['fetchCompany', companyId],
        queryFn: () => {
            return openApiRef.current.companies
                .getCompany(companyId)
                .then((response) => {
                    return response.data.data.company;
                });
        }
    });

    return {
        status,
        company: data,
        refetch: () => {
            void refetch();
        }
    };
}
